import { render, staticRenderFns } from "./CreateAutomaticAfleveringsbonnenOfDeliveredGoodsModal.vue?vue&type=template&id=d8c36678&scoped=true"
import script from "./CreateAutomaticAfleveringsbonnenOfDeliveredGoodsModal.vue?vue&type=script&lang=ts"
export * from "./CreateAutomaticAfleveringsbonnenOfDeliveredGoodsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c36678",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8c36678')) {
      api.createRecord('d8c36678', component.options)
    } else {
      api.reload('d8c36678', component.options)
    }
    module.hot.accept("./CreateAutomaticAfleveringsbonnenOfDeliveredGoodsModal.vue?vue&type=template&id=d8c36678&scoped=true", function () {
      api.rerender('d8c36678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/CreateAutomaticAfleveringsbonnenOfDeliveredGoodsModal.vue"
export default component.exports